<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="part" id="pt01">
<h1 class="pt"><a class="page" id="px"></a><a class="page" id="pxi"></a><a class="xref" href="#/umaHUANG0008#toc">The Selfish Youngsters</a></h1>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// uma-HUANG-0010.vue?38f561f5